<template>
  <div class="main-content login">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">Register</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="login-container">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-md-push-3">
            <div class="border-1px p-25">
              <h4 class="text-theme-colored text-uppercase m-0">Verifikasi Kode Pasien</h4>
              <div class="line-bottom mb-30"></div>
              <form
                id="register-form"
                name="register-form"
                class="mt-30"
                method="post"
                action
                novalidate="novalidate"
                onsubmit="return false"
              >
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group mb-10 form-verify">
                      <label>
                        Kode verifikasi sudah dikirim ke email Anda, silahkan cek
                        <span>inbox</span> atau
                        <span>spam</span>
                      </label>
                      <input
                        :disabled="disabled"
                        v-model="form_code"
                        name="tlp"
                        class="form-control"
                        type="text"
                        required
                        placeholder="Masukkan Kode Verifikasi"
                        aria-required="true"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group mb-0 mt-20">
                  <button
                    :disabled="disabled"
                    type="submit"
                    @click="postVerification"
                    class="btn btn-circled btn-dark btn-theme-colored"
                  >
                    <i v-if="show_loading" class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
                    <span v-if="!show_loading">Verifikasi</span>
                  </button>
                  <button
                    :disabled="disabled_resend"
                    type="submit"
                    @click="postResend"
                    class="btn btn-circled btn-dark btn-theme-colored"
                  >
                    <i v-if="show_loading_resend" class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
                    <span v-if="!show_loading_resend">Kirim Ulang Kode Verifikasi</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import router from "../router";
import api from "../services/api";

export default {
  data() {
    return {
      form_code: "",
      disabled: false,
      show_loading: false,
      disabled_resend: false,
      show_loading_resend: false,
    };
  },
  methods: {
    postVerification() {
      if (this.form_rm == "") {
        alert("Seluruh form harus diisi dengan benar");
        this.show_loading = false;
        this.disabled = false;
      } else {
        this.show_loading = true;
        this.disabled = true;

        let getUserData = JSON.parse(localStorage.getItem("user_data"));

        let payload = {
          email: getUserData.email,
          verification_code: this.form_code,
        };

        api
          .post(api.route.post.verify, payload)
          .then((res) => {
            let status = res.status;
            let message = res.message;
            let data = res.data;

            if (status) {
              let dataLogin = {
                logged: true,
                email: data.email,
                phone: data.phone,
                rm: data.rm,
                user_privilege_id: data.user_privilege_id,
                verify: data.verify,
              };
              localStorage.setItem("user_data", JSON.stringify(dataLogin));

              router.push({ name: "home" });
              window.location.reload();
              this.show_loading = false;
              this.disabled = false;
            }
          })
          .catch((err) => {
            alert(err);
            this.show_loading = false;
            this.disabled = false;
          });
      }
    },
    postResend() {
      this.show_loading_resend = true;
      this.disabled_resend = true;

      let getUserData = JSON.parse(localStorage.getItem("user_data"));
      let payload = { email: getUserData.email };

      api
        .post(api.route.post.resend, payload)
        .then((res) => {
          let status = res.status;
          let message = res.message;
          let data = res.data;

          alert(message);
          this.show_loading_resend = false;
          this.disabled_resend = false;
        })
        .catch((err) => {
          alert(err);
          this.show_loading_resend = false;
          this.disabled_resend = false;
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Verification.vue